<template>
  <div class="animated fadeIn">
    <router-view @refresh="refresh()"></router-view>
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        서버 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">서버 목록</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail_search -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">등록일</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            ~
          </b-form-group>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">사용 방식</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-form-radio-group id="radio-group-2" v-model="so.opt.mode" v-b-tooltip.hover title="검색하려는 사용 모드를 입력하십시오">
              <b-form-radio value="2" @click="so.sv=`mode`"><b-badge variant="danger">차단모드</b-badge></b-form-radio>
              <b-form-radio value="1" @click="so.sv=`mode`"><b-badge variant="warning">탐지모드</b-badge></b-form-radio>
              <b-form-radio value="0" @click="so.sv=`mode`"><b-badge varinat="secondary">미사용</b-badge></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">이름</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group label-for="ph_code" v-b-tooltip.hover title="찾고자 하는 닉네임을 입력해주세요">
            <b-form-input v-model="so.sv" @click="so.sk='nickname';"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-4">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh" > 검색 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="so.adv = false"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail_search -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1"  @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" :disabled="so.adv" :text="so.skt || 'Search'" size="sm" v-model="so.sk" name="sel1" id="sel1" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="group.groupname">그룹</option>
              <option value="nickname">이름</option>
              <option value="ip_addr">서버</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input v-model="so.sv" class="form-control col-xl-12"  @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="so.adv = !so.adv">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" v-model="filter_is_del">삭제된 항목 숨기기</b-checkbox>
          </div>
          <div class="mb7" sm="4" v-if="only_select">
            <b-button size="sm" variant="primary" @click="multi_all"> 전체 선택 </b-button>
            <b-button size="sm" variant="warning" @click="multi_clear"> 지우기 </b-button>
          </div>
          <div class="mb7" sm="4" v-else>
            <select class="form-control" v-model="so.perPage" @change="refresh">
              <option value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table
            class="table table_add table-striped"
            :tbody-tr-class="rowClass"
            ref="_wc_agent_list"
            responsive="sm"
            striped hover fixed
            :items="getItems"
            :fields="fields"
            :current-page="so.currentPage"
            empty-text="관련된 정보가 없어요."
            :per-page="so.perPage"
            v-show="show"
            :sortBy="so.sk"
            @row-clicked="multi_click"
            style="cursor:pointer;"
            >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">선택</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">선택안함</span>
              </template>
            </template>
            <template slot="id" slot-scope="row">
              {{only_select != true ? startRow - row.index : ''}}
              <b-form-checkbox :disabled="agent_id == row.item.id" v-if="only_select" v-model="row.item.check" @change="multi_one($event, row)"></b-form-checkbox>
            </template>
            <!-- <template slot="is_alive" slot-scope="row">
              <b-badge variant="success" v-if="pong.list.indexOf(row.item.id) > -1">온라인</b-badge>
              <b-badge v-else variant="secondary">오프라인</b-badge>
            </template> -->
            <template slot="group" slot-scope="row">
              <del v-if="row.item.is_del">{{ row.item.group ? row.item.group.groupname : '-' }}</del>
              <span v-else>{{ row.item.group ? row.item.group.groupname : '-' }}</span>
            </template>
            <template slot="mode" slot-scope="row">
              <!-- <b-badge @click="modal_multi = true" v-if="row.item.manage_id && row.item.manage_id > 0" variant="dark">Multiplexing(?)</b-badge> -->
              <b-badge v-if="row.item.mode == 0" variant="secondary">Off</b-badge>
              <b-badge v-else-if="row.item.mode == 1" variant="warning">탐지</b-badge>
              <b-badge v-else-if="row.item.mode == 2" variant="danger">On</b-badge>
              <b-badge v-else variant="dark">None</b-badge>
            </template>
            <template slot="server" slot-scope="row">
              <span v-if="!row.item.ip_addr && !row.item.version">-</span>
              <span v-else>{{row.item.ip_addr}}</span>
            </template>
            <template slot="nickname" slot-scope="row">
              <!-- <b-button variant="info" class="pull-right" size="sm" @click="update_nickname = row.item; nickname_modify_modal = true;">Modify</b-button> -->
              <del v-if="row.item.is_del">{{row.item.nickname ? row.item.nickname : '-'}}</del>
              <span v-else>{{row.item.nickname ? row.item.nickname : '-'}}</span>
            </template>
            <template slot="domain" slot-scope="row">
              <span @click="modal_domain = true; modal_domain_info = row.item.policy" style="cursor:pointer" v-if="row.item.policy && row.item.policy.domains && row.item.policy.domains.length > 0">
                <b-badge v-if="mode_count(row.item, { mode : 'DetectionOnly' }) > 0" variant="warning">탐지 : {{mode_count(row.item, { mode : 'DetectionOnly' })}}</b-badge>
                <b-badge v-if="mode_count(row.item, { mode : 'On' }) > 0" variant="danger">차단 : {{mode_count(row.item, { mode : 'On' })}}</b-badge>
                <b-badge v-if="mode_count(row.item, { mode : 'On' }) + mode_count(row.item, { mode : 'DetectionOnly' }) < 1" variant="dark">Off</b-badge>
                <!-- {{row.item.policy.domains.length}} -->
                <b-button v-if="row.item.policy.domains.length > 1" size="sm" variant="add">?</b-button>
              </span>
              <span v-else>-</span>
            </template>
            <!-- <template slot="select" slot-scope="row">
              <b-button size="sm" v-if="row.item.is_alive" @click="modal_del = true; del_info = row.item" variant="danger">제거</b-button>
            </template> -->
          </b-table>
          <template v-if="!show">
            <b-card>
              <tr>
                <th>설치된 서버가 없어요.</th>
              </tr>
            </b-card>
          </template>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- <b-modal class="modal-dialog modal-dialog-centered modal-danger" title="Delete" v-model="modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> 이곳에서 에이전트를 삭제해도 서버에서는 자동삭제되지 않습니다. 먼저 서버에서 삭제할 것을 권장드립니다. </p>
      <p> 삭제된 경우 방화벽 역활을 수행하지 않습니다.  </p>
      <p> <b> * 서버 이름 확인 </b> </p>
      <p> 삭제할 서버이름 확인 : {{del_info.nickname}}  </p>
      <b-form-input v-model="del_nickname" placeholder="등록 취소할 서버의 이름을 입력합니다."></b-form-input>
    </b-modal> -->
    <b-modal class="modal-dialog modal-dialog-centered" title="도메인 상세" v-model="modal_domain" @ok="modal_domain = false" ok-only ok-title="확인" ok-variant="outline-primary">
      <b-table striped hover small fixed class="table-responsive-sm" :items="modal_domain_info.domains" :fields="domain_manage_fields" empty-text="관련된 정보가 없어요.">
        <template slot="domain" slot-scope="row">{{row.item.domain}} <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge></template>
        <template slot="mode" slot-scope="row">
          <b-badge v-if="row.item.mode == 'Off'" variant="secondary">미사용</b-badge>
          <b-badge v-else-if="row.item.mode == 'DetectionOnly'" variant="warning">탐지모드</b-badge>
          <b-badge v-else-if="row.item.mode == 'On'" variant="danger">차단모드</b-badge>
          <b-badge v-else>None</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
      </b-table>
    </b-modal>
    <!-- <b-modal title="Using Multiplexing" v-model="modal_multi" @ok="modal_multi = false" header-bg-variant="warning" ok-only>
      <h5>Managed by a multiplexed firewall policy</h5>
    </b-modal> -->
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
